class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (!this.header) return;

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.setHeaderHeight();
    this.mediaQuery = window.matchMedia('(max-width: 990px)');
    this.boundSetHeaderHeight = this.setHeaderHeight.bind(this);
    this.mediaQuery.addEventListener('change', this.boundSetHeaderHeight);

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => {
      this.preventReveal = true;
    };

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }

  setHeaderHeight() {
    if (this.header) {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    if (this.mediaQuery && this.boundSetHeaderHeight) {
      this.mediaQuery.removeEventListener('change', this.boundSetHeaderHeight);
    }
  }

  createObserver() {
    const observer = new IntersectionObserver((entries, currentObserver) => {
      this.headerBounds = entries[0].intersectionRect;
      currentObserver.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) this.searchModal.close(false);
  }
}

class StaticHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (!this.header) return;

    this.setHeaderHeight();
    this.mediaQuery = window.matchMedia('(max-width: 990px)');
    this.boundSetHeaderHeight = this.setHeaderHeight.bind(this);
    this.mediaQuery.addEventListener('change', this.boundSetHeaderHeight);
  }

  disconnectedCallback() {
    if (this.mediaQuery && this.boundSetHeaderHeight) {
      this.mediaQuery.removeEventListener('change', this.boundSetHeaderHeight);
    }
  }

  setHeaderHeight() {
    if (this.header) {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
if (!customElements.get('static-header')) {
  customElements.define('static-header', StaticHeader);
}
